import Vue              from  'vue'
import VueRouter        from  'vue-router'
import Home             from  '@/components/HomeComponent/Home'

//Login
import Login            from  '@/components/LoginComponent/Login'
import Logout           from  '@/components/Logout'

//START: Facilities
import Facility         from  '@/components/FacilityComponent/Facility'
import FacilityDetail   from  '@/components/FacilityComponent/FacilityDetail'
//END: Facilities

import Instruction   from  '@/components/Instruction'

//START: Buildings
import Building                   from  '@/components/BuildingComponent/Buildings/Building'
import BuildingDetail             from  '@/components/BuildingComponent/Buildings/BuildingDetail'
import Level                      from  '@/components/BuildingComponent/Levels/Level'
import LevelDetail                from  '@/components/BuildingComponent/Levels/LevelDetail'
import Area                       from  '@/components/BuildingComponent/Areas/Area'
import AreaDetail                 from  '@/components/BuildingComponent/Areas/AreaDetail'
import Room                       from  '@/components/BuildingComponent/Rooms/Room'
import MassEditRooms              from  '@/components/BuildingComponent/Rooms/MassEditRooms/MassEditRooms'
import CustomRoomsComponent       from  '@/components/BuildingComponent/Rooms/CustomRooms/CustomRoomsComponent'
import RoomDetail                 from  '@/components/BuildingComponent/Rooms/RoomDetail'
import RoomType                   from  '@/components/BuildingComponent/RoomTypes/RoomType'
import RoomTypeDetail             from  '@/components/BuildingComponent/RoomTypes/RoomTypeDetail'
import CostCenter                 from  '@/components/BuildingComponent/CostCenter/CostCenter'
import CostCenterDetail           from  '@/components/BuildingComponent/CostCenter/CostCenterDetail'
import CostCenterDepartment       from  '@/components/BuildingComponent/Department/Department'
import CostCenterDepartmentDetail from  '@/components/BuildingComponent/Department/DepartmentDetail'
import CostCenterPersonel         from  '@/components/BuildingComponent/Personel/Personel'
import CostCenterPersonelDetail   from  '@/components/BuildingComponent/Personel/PersonelDetail'
//END: Buildings

//START: Associates
import Associate               from  '@/components/AssociateComponent/Associates/Associate'
import AssociateDetail         from  '@/components/AssociateComponent/Associates/AssociateDetail'
import AssociateChild          from  '@/components/AssociateComponent/Associates/DetailComponent/AssociateChild'
import MassEditAssociates      from  '@/components/AssociateComponent/Associates/MassEditAssociates/MassEditAssociates'
import PermissionsTemplates    from  '@/components/AssociateComponent/Associates/PermissionsTemplates/PermissionsTemplates'
import Position                from  '@/components/AssociateComponent/Positions/Position'
import PositionDetail          from  '@/components/AssociateComponent/Positions/PositionDetail'
import Roles                   from  '@/components/AssociateComponent/Roles/Roles'
import ContractType            from  '@/components/AssociateComponent/ContractType/ContractType'
import ContractTypeDetail      from  '@/components/AssociateComponent/ContractType/ContractTypeDetail'
//END: Associates

//START: Assignments 
import DailyAssignment         from  '@/components/AssigmentsComponent/DailyAssignment/DailyAssignment'
import DailyAssignmentDetail   from  '@/components/AssigmentsComponent/DailyAssignment/DailyAssignmentDetail'
import DailyAssignmentComplete from  '@/components/AssigmentsComponent/DailyAssignment/DailyAssignmentComplete'
import MassEditDailyAssignments from  '@/components/AssigmentsComponent/DailyAssignment/MassEditDailyAssignments/MassEditDailyAssignments'
import Statues                 from  '@/components/AssigmentsComponent/Statues/Statues.vue'
import AssignmentRoomFilter    from  '@/components/AssigmentsComponent/DailyAssignment/AssignmentRoomFilter/AssignmentRoomFilter'
import TimeDetails             from  '@/components/AssigmentsComponent/DailyAssignment/TimeDetails/TimeDetails'
// import Assignment              from  '@/components/AssigmentsComponent/Assignment/Assignment'
import AssignmentEntry         from  '@/components/AssigmentsComponent/DailyAssignment/ChildComponent/AssignmentEntry'
import Shift                   from  '@/components/AssigmentsComponent/Shift/Shift'
import ShiftDetail             from  '@/components/AssigmentsComponent/Shift/ShiftDetail'
import Break                   from  '@/components/AssigmentsComponent/Shift/ChildComponent/Break'
import Task                    from  '@/components/AssigmentsComponent/Task/Task'
import TaskDetail              from  '@/components/AssigmentsComponent/Task/TaskDetail'
import ProjectTemplate         from  '@/components/AssigmentsComponent/ProjectTemplate/ProjectTemplate'
// import ProjectScheduler        from  '@/components/AssigmentsComponent/ProjectTemplate/ProjectScheduler/ProjectScheduler'
import ProjectScheduledRooms   from  '@/components/AssigmentsComponent/ProjectTemplate/ProjectScheduledRooms/ProjectScheduledRooms'
import ProjectTemplateDetail   from  '@/components/AssigmentsComponent/ProjectTemplate/ProjectTemplateDetail'
import ProjectRoomFilter       from  '@/components/AssigmentsComponent/ProjectTemplate/ProjectRoomFilter/ProjectRoomFilter'
import ProjectRoomComplete     from  '@/components/AssigmentsComponent/ProjectTemplate/ProjectRoomComplete'
// import ProjectRecurring        from  '@/components/AssigmentsComponent/ProjectTemplate/ChildComponent/ProjectRecurring'
// import ProjectWorkList         from  '@/components/AssigmentsComponent/ProjectWorkList/ProjectWorkList'
// import ProjectWorkListDetail   from  '@/components/AssigmentsComponent/ProjectWorkList/ProjectWorkListDetail'
// import ProjectWorkTask         from  '@/components/AssigmentsComponent/ProjectWorkTask/ProjectWorkTask'
// import ProjectWorkTaskDetail   from  '@/components/AssigmentsComponent/ProjectWorkTask/ProjectWorkTaskDetail'

import ServiceRequest          from  '@/components/AssigmentsComponent/ServiceRequest/ServiceRequest'
import ServiceRequestDetail    from  '@/components/AssigmentsComponent/ServiceRequest/ServiceRequestDetail'
import AssociateServiceRequest from  '@/components/AssigmentsComponent/ServiceRequest/ChildComponent/AssociateServiceRequest'
//END: Assignments

//START: Options
import BedVacant               from '@/components/OptionsComponent/BedVacant/BedVacant'
import BedVacantDetail         from '@/components/OptionsComponent/BedVacant/BedVacantDetail'
import StepCodes               from '@/components/OptionsComponent/StepCodes/StepCodes'
import MasterStepCodes          from '@/components/OptionsComponent/MasterStepCodes/MasterStepCodes'
import BedNumbers              from '@/components/OptionsComponent/BedNumbers/BedNumbers'
import VacantBedAdjustment     from '@/components/OptionsComponent/VacantBedAdjustment/VacantBedAdjustment'
import DefaultProjectCode      from '@/components/OptionsComponent/DefaultProjectCode/DefaultProjectCode'
import FloorTypes              from '@/components/OptionsComponent/FloorTypes/FloorTypes'
import TimeOff                 from '@/components/OptionsComponent/TimeOff/TimeOff'
import Groups                  from '@/components/OptionsComponent/Groups/Groups'
//END: Options

//START: Budgeting
import StaffingScenario         from '@/components/BudgetingComponent/StaffingScenarios/StaffingScenarios'
import StaffingScenarioV2       from '@/components/BudgetingComponent/StaffingScenariosV2/Update'
import StaffingScenarioV2Create from '@/components/BudgetingComponent/StaffingScenariosV2/Create'
import StaffingScenariosDetail  from '@/components/BudgetingComponent/StaffingScenarios/DetailComponent/ScenariosDetail'
import StaffingFixed            from '@/components/BudgetingComponent/StaffingFixed/StaffingFixed'
import StaffingFixedDetail      from '@/components/BudgetingComponent/StaffingFixed/StaffingFixedDetail'
import StaffingVariable         from '@/components/BudgetingComponent/StaffingVariable/StaffingVariable'
import Forecaster               from '@/components/BudgetingComponent/Forecaster/ForecasterExt'
import Wizzard                  from '@/components/BudgetingComponent/Wizzard/Wizzard'
//END: Budgeting

//START: Census
import VacantBed                from '@/components/CensusComponent/VacantBed/VacantBed'
import VacantBedDetail          from '@/components/CensusComponent/VacantBed/VacantBedDetail'
import Worksheet                from '@/components/CensusComponent/Worksheet/Worksheet'
// import WorksheetDetailMore      from '@/components/CensusComponent/Worksheet/WorksheetDetailMore'
import WorksheetDetail          from '@/components/CensusComponent/Worksheet/DetailComponent/WorksheetDetail'
// import TimeTracking             from '@/components/CensusComponent/TimeTracking/TimeTracking'
// import TimeTrackingDetailMore   from '@/components/CensusComponent/TimeTracking/TimeTrackingDetailMore'
// import TimeTrackingDetail       from '@/components/CensusComponent/TimeTracking/DetailComponent/TimeTrackingDetail'
import LogProductivity          from '@/components/CensusComponent/LogProductivity/LogProductivity'
import LogProductivityDetail    from '@/components/CensusComponent/LogProductivity/LogProductivityDetail'
// import CallIn                   from '@/components/CensusComponent/CallIn/CallIn'
// import CallInDetail             from '@/components/CensusComponent/CallIn/CallInDetail'
// import CallInTimeOff            from '@/components/CensusComponent/CallIn/DetailComponent/CallInTimeOff'
//END: Census

//START: Days off
import MasterDepartment         from '@/components/DayOffComponent/MasterDepartment/MasterDepartment'
import MasterDepartmentDetail   from '@/components/DayOffComponent/MasterDepartment/MasterDepartmentDetail'
// import RotationSetup            from '@/components/DayOffComponent/RotationSetup/RotationSetup'
import Template                 from '@/components/DayOffComponent/Template/Template'
import Schedule                 from '@/components/DayOffComponent/Schedule/Schedule'
//END: Days off
import ScheduleComplete                 from '@/components/DayOffComponent/Schedule/ScheduleComplete/ScheduleComplete'


//START: QC
// import InspectionType           from '@/components/QcComponent/InspectionType/InspectionType'
// import InspectionTypeDetail     from '@/components/QcComponent/InspectionType/InspectionTypeDetail'
// import RoomInventory              from '@/components/QcComponent/RoomInventory/RoomInventory'
// import RoomInventoryDetail        from '@/components/QcComponent/RoomInventory/RoomInventoryDetail'
// import RoomInventoryItem          from '@/components/QcComponent/RoomInventory/DetailComponent/RoomInventoryItem'
import InspectionTemplate               from '@/components/QcComponent/InspectionTemplate/InspectionTemplate'
import InspectionTemplateDetail         from '@/components/QcComponent/InspectionTemplate/InspectionTemplateDetail'
import InspectionTemplateStep           from '@/components/QcComponent/InspectionTemplate/DetailComponent/InspectionTemplateStep'
import Inspection                       from '@/components/QcComponent/Inspection/Inspection'
import InspectionComplete               from '@/components/QcComponent/Inspection/InspectionComplete/InspectionComplete'
import Survey                           from '@/components/QcComponent/Survey/Survey'
import SurveyDetail                     from '@/components/QcComponent/Survey/SurveyDetail'
import SurveyTestCompletion             from '@/components/QcComponent/SurveyTestCompletion/SurveyTestCompletion'
import SurveyTestCompletionPersonnel    from '@/components/QcComponent/SurveyTestCompletionPersonnel/SurveyTestCompletionPersonnel'
import SurveyResponses                  from '@/components/QcComponent/SurveyResponses/SurveyResponses'
import SurveyIndividualResponse         from '@/components/QcComponent/SurveyResponses/SurveyIndividualResponse'
import SurveyQuestion                   from '@/components/QcComponent/Survey/DetailComponent/SurveyQuestion'
import ProjectCodeMassDelete            from '@/components/UtilityComponent/ProjectCodeMassDelete/ProjectCodeMassDelete'
import ProjectCodeMassAdd               from '@/components/UtilityComponent/ProjectCodeMassAdd/ProjectCodeMassAdd'
import MassBedCodes                     from '@/components/UtilityComponent/MassBedCodes/MassBedCodes'
//END: QC

//START: Utilities
import WalkingNumberUpdate      from  '@/components/UtilityComponent/WalkingNumberUpdate/WalkingNumberUpdate'
//END: Utilities

//START: Reports
import Reports                  from  '@/components/ReportsComponent/Reports/Reports'
import NewReports               from  '@/components/ReportsComponent/NewReports/NewReports'
//END: Reports

//START: Dashboard redirects
import DischargeBeds from '@/components/DischargeBedsComponent/DischargeBeds'
//END: Dashboard redirects

//START: Standard Reports
import QuickReportAssociate             from  '@/components/ReportsComponent/StandardReports/StandardReportsRunning/Assignments/QuickReportAssociate'
import QuickReportSupervisor            from  '@/components/ReportsComponent/StandardReports/StandardReportsRunning/Assignments/QuickReportSupervisor'
import QuickReportAbbreviated           from  '@/components/ReportsComponent/StandardReports/StandardReportsRunning/Assignments/QuickReportAbbreviated'
import AssignmentTimeSquareFootage      from  '@/components/ReportsComponent/StandardReports/StandardReportsRunning/Assignments/AssignmentTimeSquareFootage'
import AssignmentInfoByShift            from  '@/components/ReportsComponent/StandardReports/StandardReportsRunning/Assignments/AssignmentInfoByShift'
import AssignmentDutiesWithCleanCode    from  '@/components/ReportsComponent/StandardReports/StandardReportsRunning/Assignments/AssignmentDutiesWithCleanCode'
import AssignmentTimeUtilization        from  '@/components/ReportsComponent/StandardReports/StandardReportsRunning/Assignments/AssignmentTimeUtilization'
import DailyAssignmentRooms             from  '@/components/ReportsComponent/StandardReports/StandardReportsRunning/Assignments/DailyAssignmentRooms'
import TasksStepCodesAssociation             from  '@/components/ReportsComponent/StandardReports/StandardReportsRunning/Assignments/TasksStepCodesAssociation'
import AssignmentWeeklyMinutesReport    from  '@/components/ReportsComponent/StandardReports/StandardReportsRunning/Assignments/AssignmentWeeklyMinutesReport'
import BudgetingReport                  from  '@/components/ReportsComponent/StandardReports/StandardReportsRunning/StaffingScenarios/BudgetingReport'
import RoomTypeByBuildingReport         from  '@/components/ReportsComponent/StandardReports/StandardReportsRunning/Qc/RoomTypeByBuildingReport'
import CompletedInspectionBySupervisor  from  '@/components/ReportsComponent/StandardReports/StandardReportsRunning/Qc/CompletedInspectionBySupervisor'
import SupervisorInspectionCompletionByTemplate  from  '@/components/ReportsComponent/StandardReports/StandardReportsRunning/Qc/SupervisorInspectionCompletionByTemplate'
import InspectionTemplateCompletionByRoom  from  '@/components/ReportsComponent/StandardReports/StandardReportsRunning/Qc/InspectionTemplateCompletionByRoom'
import InspectionRoomsCompletionByArea  from  '@/components/ReportsComponent/StandardReports/StandardReportsRunning/Qc/InspectionRoomsCompletionByArea'
import InspectionItemsGroupedByTemplate  from  '@/components/ReportsComponent/StandardReports/StandardReportsRunning/Qc/InspectionItemsGroupedByTemplate'
import CompletedInspection              from  '@/components/ReportsComponent/StandardReports/StandardReportsRunning/Qc/CompletedInspection'
import InspectionItemScoreOverall       from  '@/components/ReportsComponent/StandardReports/StandardReportsRunning/Qc/InspectionItemScoreOverall'
import ProductivitySummary              from  '@/components/ReportsComponent/StandardReports/StandardReportsRunning/Census/ProductivitySummary'
import ProductivitySummaryByAssociate   from  '@/components/ReportsComponent/StandardReports/StandardReportsRunning/Census/ProductivitySummaryByAssociate'
import ProductivitySummaryByAssignment  from  '@/components/ReportsComponent/StandardReports/StandardReportsRunning/Census/ProductivitySummaryByAssignment'
import MedicareTimeSummaryReport        from  '@/components/ReportsComponent/StandardReports/StandardReportsRunning/Buildings/MedicareTimeSummaryReport'
import BuildingRoomUsageReport          from  '@/components/ReportsComponent/StandardReports/StandardReportsRunning/Buildings/BuildingRoomUsageReport'
import AssociateQCHistoryReport         from  '@/components/ReportsComponent/StandardReports/StandardReportsRunning/Associates/AssociateQCHistoryReport'
import ProjectAssignmentReport          from  '@/components/ReportsComponent/StandardReports/StandardReportsRunning/Projects/ProjectAssignmentReport'
import ProjectCompletionRoom            from  '@/components/ReportsComponent/StandardReports/StandardReportsRunning/Projects/ProjectCompletionRoom'
import NextScheduledProjectsReport      from  '@/components/ReportsComponent/StandardReports/StandardReportsRunning/Projects/NextScheduledProjectsReport'
import DefaultProjectTask               from  '@/components/ReportsComponent/StandardReports/StandardReportsRunning/Options/DefaultProjectTask'

//END: Reports

// START: RecycleBin
import RecycleBin  from  '@/components/RecycleBinComponent/RecycleBin'
// END: RecycleBin

// START: Profile
import ChangePassword  from  '@/components/ProfileComponent/ChangePassword/ChangePassword'
// END: Profile

//START: Guides
import MainViewGuide  from  '@/components/GuideComponent/MainViewGuide'
import ReportGuide  from  '@/components/GuideComponent/ReportGuide'
// END: Guides

//START: Auth
import MainViewAuth  from  '@/components/AuthComponent/MainViewAuth'
import FirstTimePassword  from  '@/components/AuthComponent/FirstTimePassword'
import ResetPassword  from  '@/components/AuthComponent/ResetPassword'
// END: Auth

import ProtectedView  from  '@/components/ProtectedView'
import ErrorView  from  '@/components/Error404'

Vue.use(VueRouter)

  const routes = [
    {
      path: "/",
      component: ProtectedView,
      children: [
        {
          path:       '/',
          name:       'home-group',
          component:  Home
        },
        {
          path:       '/facility',
          name:       'facility-group',
          component:  Facility,
        },
        {
          path:       '/facility/:id',
          name:       'facility-group',
          component:  FacilityDetail
        },
        {
          path:       '/buildings',
          name:       'building-group',
          component:  Building
        },
        {
          path:       '/building/:id',
          name:       'building-group',
          component:  BuildingDetail
        },
        {
          path:       '/building-levels',
          name:       'building-group',
          component:  Level
        },
        {
          path:       '/building-level/:id',
          name:       'building-group',
          component:  LevelDetail
        },
        {
          path:       '/building-areas',
          name:       'building-group',
          component:  Area
        },
        {
          path:       '/building-area/:id',
          name:       'building-group',
          component:  AreaDetail
        },
        {
          path:       '/building-rooms',
          name:       'building-group',
          component:  Room
        },
        {
          path:       '/building-rooms-mass-edit',
          name:       'building-group',
          component:  MassEditRooms
        },
        {
          path:       '/custom-room-descriptions',
          name:       'building-group',
          component:  CustomRoomsComponent
        },
        {
          path:       '/building-room/:id',
          name:       'building-group',
          component:  RoomDetail
        },
        {
          path:       '/building-room-types',
          name:       'building-group',
          component:  RoomType
        },
        {
          path:       '/building-room-types/:id',
          name:       'buildding-group',
          component:  RoomTypeDetail
        },
        {
          path:       '/building-cost-center',
          name:       'building-group',
          component:  CostCenter
        },
        {
          path:       '/building-cost-center/:id',
          name:       'building-group',
          component:   CostCenterDetail 
        },
        {
          path:       '/building-departments',
          name:       'building-group',
          component:  CostCenterDepartment
        },
        {
          path:     '/building-department/:id',
          name:     'building-group',
          component: CostCenterDepartmentDetail
        },
        {
          path:       '/building-personel',
          name:       'building-group',
          component:  CostCenterPersonel
        },
        {
          path:       '/building-personel/:id',
          name:       '/building-group',
          component:  CostCenterPersonelDetail
        },
        {
          path:       '/associates',
          name:       'associates-group',
          component:  Associate
        },
        {
          path:       '/associates-detail/:id',
          name:       'associates-group',
          component:  AssociateDetail
        },
        {
          path:       '/associate/:id',
          name:       'associates-group',
          component:  AssociateChild
        },
        {
          path:       '/associates-mass-edit',
          name:       'associates-group',
          component:  MassEditAssociates
        },
        {
          path:       '/permissions-templates',
          name:       'associates-group',
          component:  PermissionsTemplates
        },
        {
          path:       '/associate-positions',
          name:       'associates-group',
          component:  Position
        },
        {
          path:       '/associate-roles',
          name:       'associates-group',
          component:  Roles
        },
        {
          path:       '/associate-positions/:id',
          name:       'associates-group',
          component:  PositionDetail
        },
        {
          path:       '/associate-contract-types',
          name:       'associates-group',
          component:  ContractType
        },
        {
          path:       '/associate-contract-types/:id',
          name:       'associates-group',
          component:  ContractTypeDetail
        },
        {
          path:       '/assignment-daily-assignments',
          name:       'assignments-group',
          component:  DailyAssignment
        },
        {
          path:       '/assignment-daily-assignments/:id',
          name:       'assignments-group',
          component:  DailyAssignmentDetail
        },
        {
          path:       '/assignment-daily-assignment-complete/:id',
          name:       'assignments-group',
          component:  DailyAssignmentComplete
        },
        {
            path:       '/assignment-mass-edit',
            name:       'assignments-group',
            component:  MassEditDailyAssignments
        },
        {
          path:       '/assignment-statuses',
          name:       'assignments-group',
          component:  Statues
        },
        {
          path:       '/assignment-daily-assignments-rooms/:id',
          name:       'assignments-group',
          component:  AssignmentRoomFilter
        },
        {
          path:       '/assignment-daily-assignments-time-details/:id',
          name:       'assignments-group',
          component:  TimeDetails
        },
        {
          path:       '/assignment-entry/:id',
          name:       'assignments-group',
          component:  AssignmentEntry
        },
        {
          path:       '/assignment-shifts',
          name:       'assignments-group',
          component:  Shift
        },
        {
          path:       '/assignment-shifts/:id',
          name:       'assignments-group',
          component:  ShiftDetail
        },
        {
          path:       '/breaks',
          name:       'assignments-group',
          component:  Break
        },
        {
          path:       '/assignment-tasks',
          name:       'assignments-group',
          component:  Task
        },
        {
          path:       '/assignment-tasks/:id',
          name:       'assignments-group',
          component:  TaskDetail
        },
        {
          path:       '/assignment-projects',
          name:       'assignments-group',
          component:  ProjectTemplate
        },
        // {
        //   path:       '/assignment-projects-scheduler',
        //   name:       'assignments-group',
        //   component:  ProjectScheduler
        // },
        {
          path:       '/assignment-projects-scheduled-rooms',
          name:       'assignments-group',
          component:  ProjectScheduledRooms
        },
        {
          path:       '/assignment-project/:id',
          name:       'assignments-group',
          component:  ProjectTemplateDetail
        },
        {
          path:       '/assignment-project-complete/:id',
          name:       'assignments-group',
          component:  ProjectRoomComplete
        },
        {
          path:       '/assignment-projects-rooms/:id',
          name:       'assignments-group',
          component:  ProjectRoomFilter,
        },
        // {
        //   path:       '/assignment-project-templates/:id',
        //   name:       'assignments-group',
        //   component:  ProjectRecurring
        // },
        // {
        //   path:       '/assignment-project-work-lists',
        //   name:       'assignments-group',
        //   component:  ProjectWorkList
        // },
        // {
        //   path:       '/assignment-project-work-lists/:id',
        //   name:       'assignments-group',
        //   component:  ProjectWorkListDetail
        // },
        // {
        //   path:       '/assignment-project-work-tasks',
        //   name:       'assignments-group',
        //   component:  ProjectWorkTask
        // },
        // {
        //   path:       '/assignment-project-work-tasks/:id',
        //   name:       'assignments-group',
        //   component:  ProjectWorkTaskDetail
        // },
        {
          path:       '/assignment-service-request',
          name:       'assignments-group',
          component:  ServiceRequest
        },
        {
          path:       '/assignment-service-request-detail/:id',
          name:       'assignments-group',
          component:  ServiceRequestDetail
        },
        {
          path:       '/assignment-service-request/:id',
          name:       'assignments-group',
          component:  AssociateServiceRequest
        },

    /**-- Options Group------------------------------------------------------------------------------- */    
        {
          path:       '/options-bed-codes',
          name:       'options-group',
          component:  BedVacant
        },
        {
          path:       '/options-bed-codes/:id',
          name:       'options-group',
          component:  BedVacantDetail
        },
        {
          path:       '/options-step-codes',
          name:       'options-group',
          component:  StepCodes
        },
        {
          path:       '/qc-inspection-items',
          name:       'qc-group',
          component:  MasterStepCodes
        },
        {
          path:       '/options-bed-numbers',
          name:       'options-group',
          component:  BedNumbers
        },
        {
          path:       '/options-vacant-bed-adjustment',
          name:       'options-group',
          component:  VacantBedAdjustment
        },
        {
          path:       '/options-default-project-codes',
          name:       'options-group',
          component:  DefaultProjectCode
        },
        {
          path:       '/options-floor-types',
          name:       'options-group',
          component:  FloorTypes
        },
        {
          path:       '/options-time-off',
          name:       'options-group',
          component:  TimeOff
        },
        {
          path:       '/options-groups',
          name:       'options-group',
          component:  Groups
        },
        /**
         * 
         * Todas las propiedades 'name' de este grupo deben llamarse igual ya que pertenencen al mismo,
         * esto tambien es para mantener el comportamiento 'active' de la clase css que mantiene al boton
         * del menu presionado mientras te mantienes en cualquier seccion de este grupo.
         * 
         */
      /**--------------------------------------------------------------------------------- */ 
      /**--Budgeting Group-----------------------------------------------------------------*/
      {
        path:         '/budgeting-staffing-scenario',
        name:         'budgeting-group',
        component:    StaffingScenario
      },
      {
        path:         '/budgeting-staffing-scenario/update/:id',
        name:         'budgeting-group',
        component:    StaffingScenarioV2
      },
      {
        path:         '/budgeting-staffing-scenario/create',
        name:         'budgeting-group',
        component:    StaffingScenarioV2Create
      },
      {
        path:         '/budgeting-staffing-scenario/:id',
        name:         'budgeting-group',
        component:    StaffingScenariosDetail
      },
      {
        path:         '/budgeting-staffing-fixed',
        name:         'budgeting-group',
        component:    StaffingFixed
      },
      {
        path:         '/budgeting-staffing-fixed/:id',
        name:         'budgeting-group',
        component:    StaffingFixedDetail
      },
      {
        path:         '/budgeting-staffing-variable/:id',
        name:         'budgeting-group',
        component:    StaffingVariable
      },
      {
        path:         '/budgeting-forecaster',
        name:         'budgeting-group',
        component:    Forecaster
      },
      {
        path:         '/budgeting-staffing-scenario/wizzard/:id',
        name:         'budgeting-group',
        component:    Wizzard
      },
      /**--------------------------------------------------------------------------------- */
      /**--Census Group-----------------------------------------------------------------*/
      {
        path:         '/census-vacant-beds',
        name:         'census-group',
        component:    VacantBed
      },
      {
        path:         '/census-vacant-beds/:id',
        name:         'census-group',
        component:    VacantBedDetail
      },
      {
        path:         '/census-worksheets',
        name:         'census-group',
        component:    Worksheet
      },
      {
        path:         '/census-worksheets/:id',
        name:         'census-group',
        component:    WorksheetDetail
      },
      // {
      //   path:         '/census-worksheets-detail/:id',
      //   name:         'census-group',
      //   component:    WorksheetDetailMore
      // },
      // {
      //   path:         '/census-time-tracking',
      //   name:         'census-group',
      //   component:    TimeTracking
      // },
      // {
      //   path:         '/census-time-tracking/:id',
      //   name:         'census-group',
      //   component:    TimeTrackingDetail
      // },
      // {
      //   path:         '/census-time-tracking-detail/:id',
      //   name:         'census-group',
      //   component:    TimeTrackingDetailMore
      // },
      {
        path:         '/census-log-productivity',
        name:         'census-group',
        component:    LogProductivity
      },
      {
        path:         '/census-log-productivity/:id',
        name:         'census-group',
        component:    LogProductivityDetail
      },
      // {
      //   path:         '/census-call-in',
      //   name:         'census-group',
      //   component:    CallIn
      // },
      // {
      //   path:         '/census-call-in-detail/:id',
      //   name:         'census-group',
      //   component:    CallInDetail
      // },
      // {
      //   path:         '/census-call-in/:id',
      //   name:         'census-group',
      //   component:    CallInTimeOff
      // },

      /**--------------------------------------------------------------------------------- */
      /**--Day Off Group-----------------------------------------------------------------*/
      {
        path:         '/days-off-rotation-templates',
        name:         'days-off-group',
        component:    MasterDepartment
      },
      {
        path:         '/days-off-master-departments/:id',
        name:         'days-off-group',
        component:    MasterDepartmentDetail
      },
      // {
      //   path:         '/days-off-rotation-setups',
      //   name:         'days-off-group',
      //   component:    RotationSetup
      // }, // No in use
      {
        path:         '/days-off-templates',
        name:         'days-off-group',
        component:    Template
      },
      {
        path:         '/days-off-schedules',
        name:         'days-off-group',
        component:    Schedule
      },
      {
        path:         '/schedule-complete/:id',
        name:         'schedule-complete',
        component:    ScheduleComplete
      },
      /**--------------------------------------------------------------------------------- */
      /**--------QC Group-----------------------------------------------------------------*/
      // {
      //   path:       '/qc-inspection-type',
      //   name:       'qc-group',
      //   component:  InspectionType
      // }, // No in use
      // {
      //   path:       '/qc-inspection-type/:id',
      //   name:       'qc-group',
      //   component:  InspectionTypeDetail
      // }, // No in use
      // {
      //   path:       '/qc-room-inventory',
      //   name:       'qc-group',
      //   component:  RoomInventory
      // },
      // {
      //   path:       '/qc-room-inventory-detail/:id',
      //   name:       'qc-group',
      //   component:  RoomInventoryDetail
      // },
      // {
      //   path:       '/qc-room-inventory/:id',
      //   name:       'qc-group',
      //   component:   RoomInventoryItem
      // },
      {
        path:       '/qc-inspection-template',
        name:       'qc-group',
        component:  InspectionTemplate
      },
      {
        path:       '/qc-inspection-template-detail/:id',
        name:       'qc-group',
        component:  InspectionTemplateDetail
      },
      {
        path:       '/qc-inspection-template/:id',
        name:       'qc-group',
        component:  InspectionTemplateStep
      },
      {
        path:       '/qc-inspection',
        name:       'qc-group',
        component:  Inspection
      },
      {
        path:       '/qc-inspections/:id',
        name:       'qc-group',
        component:  InspectionComplete
      },
      // {
      //   path:       '/qc-template-inspections',
      //   name:       'qc-group',
      //   component:  Inspection
      // },
      {
        path:       '/qc-surveys',
        name:       'qc-group',
        component:  Survey
      },
      {
        path:       '/qc-surveys-detail/:id',
        name:       'qc-group',
        component:  SurveyDetail
      },
      {
        path:       '/qc-survey-test-completion/:id',
        name:       'qc-group',
        component:  SurveyTestCompletion
      },
      {
        path:       '/qc-survey-responses/:id',
        name:       'qc-group',
        component:  SurveyResponses
      },
      {
        path:       '/qc-individual-response/:id',
        name:       'qc-group',
        component:  SurveyIndividualResponse
      },
      {
        path:       '/qc-surveys/:id',
        name:       'qc-group',
        component:  SurveyQuestion
      },
      
      /**--------------------------------------------------------------------------------- */

      /**--------Utilities Group-----------------------------------------------------------------*/
      {
        path:       '/utilities-walking-number-update',
        name:       'utilities-group',
        component:  WalkingNumberUpdate
      },
      {
        path:       '/utilities-project-codes-mass-delete',
        name:       'utilities-group',
        component:  ProjectCodeMassDelete
      },
      {
        path:       '/utilities-project-codes-mass-add',
        name:       'utilities-group',
        component:  ProjectCodeMassAdd
      },
      {
        path:       '/utilities-mass-restore-bed-codes',
        name:       'utilities-group',
        component:  MassBedCodes
      },
      {
        path:       '/recycle-bin',
        name:       'utilities-group',
        component:  RecycleBin
      },
      /**--------------------------------------------------------------------------------- */

      /**--------Reports Group-----------------------------------------------------------------*/
      {
        path:       '/reports',
        name:       'reports-group',
        component:  Reports
      },
      {
        path:       '/new-reports/:report_name',
        name:       'reports-group',
        component:  NewReports
      },
       /**--------------------------------------------------------------------------------- */

      /**--------Dashboard redirects-----------------------------------------------------------------*/

      {
        path:       '/discharge-beds',
        name:       '',
        component:  DischargeBeds
      },

       /**--------------------------------------------------------------------------------- */

      /**--------Standard Reports Group-----------------------------------------------------------------*/
      {
        path: '/standard-reports/assignment/quick-report-supervisor/:id',
        name: 'reports-group',
        component: QuickReportSupervisor,
      },
      {
        path: '/standard-reports/assignment/quick-report-associate/:id',
        name: 'reports-group',
        component: QuickReportAssociate,
      },
      {
        path: '/standard-reports/assignment/quick-report-abbreviated/:id',
        name: 'reports-group',
        component: QuickReportAbbreviated,
      },
      {
        path: '/standard-reports/assignment/assignment-time-square-footage',
        name: 'reports-group',
        component: AssignmentTimeSquareFootage,
      },
      {
        path: '/standard-reports/assignment/assignment-info-by-shift',
        name: 'reports-group',
        component: AssignmentInfoByShift,
      },
      {
        path: '/standard-reports/assignment/assignment-duties-with-clean-code',
        name: 'reports-group',
        component: AssignmentDutiesWithCleanCode,
      },
      {
        path: '/standard-reports/assignment/assignment-time-utilization',
        name: 'reports-group',
        component: AssignmentTimeUtilization,
      },
      {
        path: '/standard-reports/assignment/over-under-unassigned-rooms',
        name: 'reports-group',
        component: DailyAssignmentRooms,
      },
      {
        path: '/standard-reports/assignment/tasks-step-codes-association',
        name: 'reports-group',
        component: TasksStepCodesAssociation,
      },
      {
        path: '/standard-reports/assignment/assignment-weekly-minutes-report',
        name: 'reports-group',
        component: AssignmentWeeklyMinutesReport,
      },
      {
        path: '/standard-reports/staffing-scenario/budgeting-report/:id',
        name: 'reports-group',
        component: BudgetingReport,
      },
      {
        path: '/standard-reports/qc/room-type-summary-by-building',
        name: 'reports-group',
        component: RoomTypeByBuildingReport,
      },
      {
        path: '/standard-reports/qc/completed-inspection-by-supervisor',
        name: 'reports-group',
        component: CompletedInspectionBySupervisor,
      },
      {
        path: '/standard-reports/qc/supervisor-inspection-completion-report-by-template',
        name: 'reports-group',
        component: SupervisorInspectionCompletionByTemplate,
      },
      {
        path: '/standard-reports/qc/inspection-template-completion-by-room',
        name: 'reports-group',
        component: InspectionTemplateCompletionByRoom,
      },
      {
        path: '/standard-reports/qc/inspection-rooms-completion-by-area',
        name: 'reports-group',
        component: InspectionRoomsCompletionByArea,
      },
      {
        path: '/standard-reports/qc/inspection-items-grouped-by-template',
        name: 'reports-group',
        component: InspectionItemsGroupedByTemplate,
      },
      {
        path: '/standard-reports/qc/completed-inspection',
        name: 'reports-group',
        component: CompletedInspection,
      },
      {
        path: '/standard-reports/qc/inspection-item-score-overall',
        name: 'reports-group',
        component: InspectionItemScoreOverall,
      },
      {
        path: '/standard-reports/census/productivity-summary',
        name: 'reports-group',
        component: ProductivitySummary,
      },
      {
        path: '/standard-reports/census/productivity-summary-by-associate',
        name: 'reports-group',
        component: ProductivitySummaryByAssociate,
      },
      {
        path: '/standard-reports/census/productivity-summary-by-assignment',
        name: 'reports-group',
        component: ProductivitySummaryByAssignment,
      },
      {
        path: '/standard-reports/buildings/medicare-time-square-footage-summary',
        name: 'reports-group',
        component: MedicareTimeSummaryReport,
      },
      {
        path: '/standard-reports/buildings/building-room-usage-report',
        name: 'reports-group',
        component: BuildingRoomUsageReport,
      },
      {
        path: '/standard-reports/buildings/associate-qc-history',
        name: 'reports-group',
        component: AssociateQCHistoryReport,
      },
      {
        path: '/standard-reports/projects/project-assignment',
        name: 'reports-group',
        component: ProjectAssignmentReport,
      },
      {
        path: '/standard-reports/projects/project-completion-room',
        name: 'reports-group',
        component: ProjectCompletionRoom,
      },
      {
        path: '/standard-reports/projects/next-scheduled-projects-report',
        name: 'reports-group',
        component: NextScheduledProjectsReport,
      },
      {
        path: '/standard-reports/options/default-project-task-frequency-report',
        name: 'reports-group',
        component: DefaultProjectTask,
      },
      {
        path: '/profile-change-password',
        name: 'profile-group',
        component: ChangePassword,
      },
      {
        path:       '/logout',
        name:       'logout-group',
        component:  Logout
      },
    ]},
    {
      path: "/guides",
      component: MainViewGuide,
      children: [
        {
          path:       '/',
          name:       'reports',
          component:  ReportGuide
        },
        {
          path:       'reports',
          name:       'reports',
          component:  ReportGuide
        },
        {
            path:       'instruction/:id',
            name:       'reports',
            component:  Instruction
        }
    ]},
    {
      path: "/guides",
      component: MainViewGuide,
      children: [
        {
          path:       '/',
          name:       'reports',
          component:  ReportGuide
        },
        {
          path:       'reports',
          name:       'reports',
          component:  ReportGuide
        }]
    },
    {
      path: "/auth",
      component: MainViewAuth,
      children: [
        {
          path:       '/',
          name:       'first-time-password',
          component:  FirstTimePassword
        },
        {
          path:       'first-time-password/:token',
          name:       'first-time-password',
          component:  FirstTimePassword
        },
        {
          path:       'reset-password',
          name:       'reset-password',
          component:  ResetPassword
        }
      ]
    },
    {
      path:       '/personnel-survey-test-completion/:id',
      name:       'personnel-survey',
      component:  SurveyTestCompletionPersonnel
    },
    
    {
      path:       '/change-password-after-days',
      name:       'ChangePasswordAfterDays',
      component:  ChangePassword
    },
    {
      path:       '/login',
      name:       'login',
      component:  Login
    },
    {
      path: "*",
      component: ErrorView
    
    }
      /**--------------------------------------------------------------------------------- */

      /**--------RecycleBin Group-----------------------------------------------------------------*/
      /**--------------------------------------------------------------------------------- */

      // {
      //   path: '/about',
      //   name: 'About',
      //   // route level code-splitting
      //   // this generates a separate chunk (about.[hash].js) for this route
      //   // which is lazy-loaded when the route is visited.
      //   component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
      // }
    ]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

const is_authenticated = () => {
  return localStorage.getItem('access_token') !== null;
}

router.beforeEach( (to, from, next) => {
  if ( to.name !== 'login' && to.name !== 'first-time-password' && to.name !== 'reset-password' && to.name !== 'personnel-survey' && !is_authenticated() ) {
    next({ name: 'login' })
  } else {
    next()
  } 
})

export default router
